import React, {Component} from 'react'
import {graphql} from 'react-apollo'
import {withNamespaces, Trans} from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import {withRouter} from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import {get, flowRight as compose} from 'lodash'
import queryString from 'querystring'
import {PaymentProviderFactory} from './PaymentProviders'
import messages from '../../../assets/messages'
import AppContext from '../../Common/contexts/AppContext'
import Typography from '@material-ui/core/Typography'
import {isMobile, safeParseJSON} from '../../../common/utils'
import {beginDepositResults} from '@bdswiss/common-enums'
import {CLIENT_PROFILE_QUERY} from '../../../graphql/queries'
import {Loading} from '../../Common/Loading'
import {InnerAppContext} from '../../../common/types'

const styles = theme => ({
  item: {
    paddingLeft: 20,
    fontSize: '1em',
    cursor: 'pointer',
    'white-space': 'pre',
  },
  paymentProviderSection: {
    padding: isMobile() ? '12px' : '100px 12px 12px 12px'
  },
  errorMessage: {
    'text-align': 'center',
    color: theme.palette.red.color,
  }
})

const PaymentMethodProviderInfoGridId = 'payment-provider-grid'

class InitiateDeposit extends Component<any,any> {

  static contextType = AppContext
  context!: InnerAppContext
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  handlePaymentError(e) {
    this.setState({hasError: true})
    //@ts-ignore
    window.location = `bdswiss://payment?result=${beginDepositResults.failed.value}`
  }

  render() {
    const {viewer, classes, history, viewerLoading, bonusAmount} = this.props
    const urlParams = queryString.parse(this.props.location.search.replace('?', ''))
    const {amount, vendor: provider, providerName, args, account} : any = urlParams
    const {paymentKey, bankCode} = safeParseJSON(args)
    const selectedPaymentOption = {
      provider,
      paymentKey: paymentKey ? paymentKey : '',
      name: providerName,
      providerBankCode: bankCode,
    }

    if (!viewer || viewerLoading) return <Loading />
    let PaymentProvider : any = null
    if (PaymentProviderFactory.hasImplementation(provider)) {
      PaymentProvider = PaymentProviderFactory.get(provider, paymentKey)
    }

    return (
      <React.Fragment>
        <Grid container justifyContent="center" alignItems="center" direction="row" spacing={3}>
          {PaymentProvider && !this.state.hasError &&
            <Grid id={PaymentMethodProviderInfoGridId} item xs={12} sm={12} lg={12} className={classes.paymentProviderSection}>
              <PaymentProvider
                viewer={viewer}
                account={JSON.parse(account)}
                amount={Number(amount)}
                providerProperties={selectedPaymentOption}
                onError={(e) => this.handlePaymentError(e)}
                history={history}
                useVirtualPaymentPage
                bonusAmount={Number(bonusAmount)}
              />
            </Grid>
          }
          {(!PaymentProvider || this.state.hasError) &&
            <Grid item xs={12} sm={12} lg={6}>
              <Typography variant="caption" className={classes.errorMessage}>
                <Trans {...messages.paymentMethodUnavailable}/>
              </Typography>
            </Grid>
          }
        </Grid>
      </React.Fragment>
    )
  }
}

export default compose(
  withRouter,
  withStyles(styles, {withTheme: true}),
  withNamespaces(),
  graphql(CLIENT_PROFILE_QUERY, {
    props: ({data: {error, loading}, data}:any) => {
      const viewer = get(data, 'viewer')
      return {
        error,
        viewerLoading: loading,
        viewer,
      }
    }
  })
)(InitiateDeposit)
